import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const GA_ID = import.meta.env.VITE_GA4_ID

// Inject the GA4 gtag.js script once
let gtagInjected = false
function injectGtag() {
  if (gtagInjected || !GA_ID) return
  gtagInjected = true

  window.dataLayer = window.dataLayer || []
  window.gtag = function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', GA_ID, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)
}

export function trackEvent(category, action, label) {
  if (import.meta.env.DEV) {
    console.log(`[Analytics] ${category} / ${action}${label ? ` / ${label}` : ''}`)
  }

  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
    })
  }
}

export function usePageView() {
  const location = useLocation()
  const initialized = useRef(false)

  useEffect(() => {
    if (!initialized.current) {
      injectGtag()
      initialized.current = true
    }
  }, [])

  useEffect(() => {
    trackEvent('navigation', 'page_view', location.pathname)

    if (typeof window.gtag === 'function' && GA_ID) {
      window.gtag('config', GA_ID, {
        page_path: location.pathname,
      })
    }
  }, [location.pathname])
}
